import React from 'react'
import { useNavigate } from 'react-router-dom';
import 'antd/dist/antd.css';
import { Button, Alert } from 'antd';
function ExamInstruction() {
    const navigate = useNavigate()

    const starttestHandle = () => {
        navigate("/question")
    }
    return (
        <>
            <div className="cont" 
            style={{ width:"90%", margin:"10px auto"}}
            >

                <div>
                <Alert message="Please read the instruction carefully" type="info" showIcon />
                </div>
                
                <div className="conteny" style={{lineHeight:"2rem",
                marginTop:"15px",
                padding:"0 100px"}}>
                    <div className="list">
                        <ol>
                            <li>Click start test on bottom of your screen to begin the test.</li>
                            <li> The clock has been set at sever and count down timer at the top Right side of the screen will display left out time to closure from where you can monitor
                                time you have to complete the exam.</li>
                            <li> Click one of the answer, simply click the desired option button.</li>
                            <li>Candidate can change their response of attempted answer anytime during examination slot time by clicking another answer which candidates want to
                                change an answer. Click to remove incorrect answer, click the desired option button.</li>
                            <li>Click on Next to save the answer and moving to the next question. The next question will automatically be displayed.</li>
                            <li>Click on Mark for Review to review you answer at later stage.</li>
                            <li>To select a question, click on the question number on the Right side of the screen.</li>
                            <li>The colour coded diagram on the Left side of the screen shows the status of the question.
                                Red Not answered /Not Attempted Question. Green Answered /Attempted Question Yellow Not Answered & Marked for review. Violet Answered & Marked of Review Gray Dumped White Not Visited</li>
                            <li>Candidate will be allowed to Shuffle between questions anytime during the examination as per their convenience.</li>
                        </ol>
                    </div>
                </div>
                <div style={{ textAlign: 'center', marginBottom: "100px" }}>
                    {/* <button ></button> */}
                    <Button onClick={starttestHandle} type="primary" htmlType="submit">
                        Start Test
                    </Button>
                </div>

            </div>
        </>
    )
}

export default ExamInstruction
